export default {
  note: {
    title: 'Special notes:',
    description: 'We’ll try our best to accommodate requests, but can’t make changes that affect pricing.',
    placeholder: 'Add special request',
  },
  buttons: {
    add: '+ Add Item',
    update_item: 'Update',
    add_to_card: 'Add to cart',
  },
  error_messages: {
    missing_fields: 'Please select all required fields.',
    product_unavailable: 'Sold out!',
  },
  labels: {
    bogo: 'Buy One, Get One Free',
  },
};
